import config from '../config';
import { ApiError } from './ApiError';
import { Tenant } from './model/tenant';
import { TranslationBatch } from './model/translation-batch';
import { getDefaultHeaders } from './helpers/api-helpers';

export async function getAvailableTranslations(tenant: Tenant): Promise<TranslationBatch[]> {
  const endpoint = `/api/v2/accounts/${tenant.accountId}/content-area/${tenant.areaId}/Translations/`;
  const url = `${config.localizationUIServerUrl}${endpoint}`;

  const results = await fetch(url, {
    method: 'GET',
    headers: getDefaultHeaders(),
  });

  if (!results.ok) {
    //error
    throw new ApiError('get available translations failed', results);
  }

  return await results.json();
}
